import { useParams } from 'react-router-dom';



export const tabs = [
  {
    id: 'newSalesOrders',
    label: "New Orders",
    requiredPermissions: []
  },
  {
    id: 'awaitingPayment',
    label: "Payment Processing",
    requiredPermissions: []
  },
  {
    id: 'awaitingApproval',
    label: "Pending Approval",
    requiredPermissions: []
  },
  {
    id: 'awaitingFulfillment',
    label: "Awaiting Item Fulfillment",
    requiredPermissions: []
  },
  {
    id: 'inTransit',
    label: "In Transit",
    requiredPermissions: []
  }
] as const;

export type ITabId = typeof tabs[number]['id'];



export function useActivityParams() {
  return useParams<{ tabId: ITabId; }>();
}
